import { render, staticRenderFns } from "./InsertionLevelInput.vue?vue&type=template&id=f15c48ce&"
import script from "./InsertionLevelInput.vue?vue&type=script&lang=js&"
export * from "./InsertionLevelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib'
installComponents(component, {
  VSelect,
})
